/**
 * Default category placeholder images from Unsplash
 * These high-quality images can be used as defaults for categories without custom images
 */

export interface CategoryImageSuggestion {
  name: string;
  keywords: string[];
  imageUrl: string;
  description: string;
}

export const defaultCategoryImages: CategoryImageSuggestion[] = [
  // Fashion
  {
    name: "Men's Fashion",
    keywords: ['mens', 'fashion', 'clothing', 'apparel', 'style'],
    imageUrl: 'https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?w=800&q=80',
    description: 'Modern menswear and style',
  },
  {
    name: "Women's Fashion",
    keywords: ['womens', 'fashion', 'clothing', 'apparel', 'style', 'dress'],
    imageUrl: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800&q=80',
    description: 'Elegant womens fashion',
  },
  {
    name: 'Shoes & Footwear',
    keywords: ['shoes', 'sneakers', 'footwear', 'boots', 'sandals'],
    imageUrl: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=800&q=80',
    description: 'Stylish footwear collection',
  },
  {
    name: 'Accessories',
    keywords: ['accessories', 'bags', 'jewelry', 'watches', 'sunglasses'],
    imageUrl: 'https://images.unsplash.com/photo-1523170335258-f5ed11844a49?w=800&q=80',
    description: 'Fashion accessories and more',
  },

  // Electronics
  {
    name: 'Electronics',
    keywords: ['electronics', 'tech', 'gadgets', 'devices'],
    imageUrl: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=800&q=80',
    description: 'Latest electronic devices',
  },
  {
    name: 'Smartphones',
    keywords: ['phone', 'mobile', 'smartphone', 'iphone', 'android'],
    imageUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=800&q=80',
    description: 'Latest smartphones and tablets',
  },
  {
    name: 'Computers & Laptops',
    keywords: ['computer', 'laptop', 'desktop', 'pc', 'macbook'],
    imageUrl: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=800&q=80',
    description: 'Computers and laptops',
  },
  {
    name: 'Audio & Headphones',
    keywords: ['audio', 'headphones', 'earbuds', 'speakers', 'sound'],
    imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800&q=80',
    description: 'Premium audio equipment',
  },
  {
    name: 'Cameras',
    keywords: ['camera', 'photography', 'lens', 'dslr', 'mirrorless'],
    imageUrl: 'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=800&q=80',
    description: 'Professional cameras and gear',
  },

  // Home & Living
  {
    name: 'Home & Living',
    keywords: ['home', 'furniture', 'decor', 'living'],
    imageUrl: 'https://images.unsplash.com/photo-1556912167-f556f1f39faa?w=800&q=80',
    description: 'Beautiful home essentials',
  },
  {
    name: 'Furniture',
    keywords: ['furniture', 'sofa', 'table', 'chair', 'bed'],
    imageUrl: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80',
    description: 'Modern furniture pieces',
  },
  {
    name: 'Home Decor',
    keywords: ['decor', 'decoration', 'interior', 'design'],
    imageUrl: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?w=800&q=80',
    description: 'Stylish home decorations',
  },
  {
    name: 'Kitchen & Dining',
    keywords: ['kitchen', 'dining', 'cookware', 'utensils'],
    imageUrl: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80',
    description: 'Kitchen essentials',
  },

  // Beauty & Personal Care
  {
    name: 'Beauty & Personal Care',
    keywords: ['beauty', 'cosmetics', 'makeup', 'skincare', 'personal'],
    imageUrl: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&q=80',
    description: 'Beauty and personal care products',
  },
  {
    name: 'Makeup',
    keywords: ['makeup', 'cosmetics', 'lipstick', 'foundation'],
    imageUrl: 'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=800&q=80',
    description: 'Premium makeup products',
  },
  {
    name: 'Skincare',
    keywords: ['skincare', 'beauty', 'serum', 'moisturizer'],
    imageUrl: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=800&q=80',
    description: 'Quality skincare products',
  },
  {
    name: 'Fragrances',
    keywords: ['perfume', 'fragrance', 'cologne', 'scent'],
    imageUrl: 'https://images.unsplash.com/photo-1541643600914-78b084683601?w=800&q=80',
    description: 'Luxury fragrances',
  },

  // Sports & Outdoors
  {
    name: 'Sports & Outdoors',
    keywords: ['sports', 'outdoor', 'fitness', 'athletic'],
    imageUrl: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&q=80',
    description: 'Sports and outdoor equipment',
  },
  {
    name: 'Sports Shoes',
    keywords: ['sports', 'shoes', 'sneakers', 'running', 'athletic'],
    imageUrl: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=80',
    description: 'Athletic footwear',
  },
  {
    name: 'Fitness Equipment',
    keywords: ['fitness', 'gym', 'equipment', 'workout', 'exercise'],
    imageUrl: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80',
    description: 'Home fitness equipment',
  },
  {
    name: 'Cycling',
    keywords: ['bike', 'bicycle', 'cycling', 'cycle'],
    imageUrl: 'https://images.unsplash.com/photo-1485965120184-e220f721d03e?w=800&q=80',
    description: 'Bicycles and accessories',
  },

  // Books & Stationery
  {
    name: 'Books',
    keywords: ['books', 'reading', 'literature', 'novel'],
    imageUrl: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80',
    description: 'Books and literature',
  },
  {
    name: 'Stationery',
    keywords: ['stationery', 'office', 'supplies', 'pen', 'notebook'],
    imageUrl: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&q=80',
    description: 'Office and stationery supplies',
  },

  // Kids & Baby
  {
    name: 'Kids & Baby',
    keywords: ['kids', 'baby', 'children', 'toys'],
    imageUrl: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=800&q=80',
    description: 'Products for kids and babies',
  },
  {
    name: 'Toys',
    keywords: ['toys', 'games', 'play', 'kids'],
    imageUrl: 'https://images.unsplash.com/photo-1558060370-d644479cb6f7?w=800&q=80',
    description: 'Fun toys and games',
  },

  // Automotive
  {
    name: 'Automotive',
    keywords: ['automotive', 'car', 'vehicle', 'auto'],
    imageUrl: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800&q=80',
    description: 'Automotive parts and accessories',
  },
  {
    name: 'Motorcycle',
    keywords: ['motorcycle', 'bike', 'motorbike', 'helmet'],
    imageUrl: 'https://images.unsplash.com/photo-1558981359-219d6364c9c8?w=800&q=80',
    description: 'Motorcycle gear and accessories',
  },

  // Jewelry & Watches
  {
    name: 'Jewelry',
    keywords: ['jewelry', 'jewellery', 'necklace', 'ring', 'earrings'],
    imageUrl: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800&q=80',
    description: 'Fine jewelry pieces',
  },
  {
    name: 'Watches',
    keywords: ['watch', 'watches', 'timepiece', 'smartwatch'],
    imageUrl: 'https://images.unsplash.com/photo-1524805444758-089113d48a6d?w=800&q=80',
    description: 'Luxury and sport watches',
  },

  // General/Fallback
  {
    name: 'General Products',
    keywords: ['product', 'item', 'shopping', 'store'],
    imageUrl: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=800&q=80',
    description: 'General products',
  },
  {
    name: 'Sale & Offers',
    keywords: ['sale', 'offer', 'discount', 'deal'],
    imageUrl: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800&q=80',
    description: 'Special offers and deals',
  },
];

/**
 * Get suggested image URL based on category name
 */
export function suggestImageForCategory(categoryName: string): string | null {
  const normalizedName = categoryName.toLowerCase();

  // Find matching suggestion
  const suggestion = defaultCategoryImages.find((img) =>
    img.keywords.some((keyword) => normalizedName.includes(keyword))
  );

  return suggestion?.imageUrl || null;
}

/**
 * Get all image suggestions for a search term
 */
export function searchImageSuggestions(searchTerm: string): CategoryImageSuggestion[] {
  if (!searchTerm) return defaultCategoryImages;

  const normalizedSearch = searchTerm.toLowerCase();

  return defaultCategoryImages.filter(
    (img) =>
      img.name.toLowerCase().includes(normalizedSearch) ||
      img.keywords.some((keyword) => keyword.includes(normalizedSearch)) ||
      img.description.toLowerCase().includes(normalizedSearch)
  );
}
